<script setup lang="ts">
import { useRouter } from "vue-router";
import Lianjie from "./../home/repeat/Lianjie.vue";
import Header from "./../home/repeat/Header.vue";
import Scroll from "./../home/repeat/Scroll.vue";
import Navbar from "../home/repeat/Navbar.vue";
import { ref, onMounted, onBeforeUnmount } from "vue";
// 是否已经显示过小容器
const hasShownSubContainers = ref(false);
const scroll = () => {
  if (!hasShownSubContainers.value) {
    const sections = document.querySelectorAll(
        ".box_inner_t .inner_t, .box_inner .inner_th, .footer"
    );
    const windowHeight = window.innerHeight;

    sections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      // 当元素进入视口 80% 的位置时触发动画
      if (rect.top <= windowHeight * 0.8) {
        section.classList.add("show");
      }
    });

    // 检查是否所有部分都已显示
    if ([...sections].every((section) => section.classList.contains("show"))) {
      hasShownSubContainers.value = true;
      window.removeEventListener("scroll", scroll);
    }
  }
};

onMounted(() => {
  window.addEventListener("scroll", scroll);
  // 初始检查
  setTimeout(scroll, 100);
});
// 可能需要在组件销毁时移除滚动事件监听器，防止内存泄漏
onBeforeUnmount(() => {
  window.removeEventListener("scroll", scroll);
});

// 在页面刷新时重置状态
window.onload = () => {
  hasShownSubContainers.value = false;
  document
    .querySelectorAll(".show")
    .forEach((el) => el.classList.remove("show"));
  setTimeout(scroll, 100);
};
</script>

<template>
  <div class="digital">
    <div class="main">
      <div class="kong">
        <Header> </Header>
      </div>
      <div class="img_box">
        <div class="img_text">
          <div class="img_inner">
            <h2>{{ $t("system.about.digital.inner_h") }}</h2>
            <div class="img_main">
              <div>{{ $t("system.about.digital.main_d") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap">
        <div class="wrap_title">
          <div class="title_box">
            <div class="title">
              <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
              <text>></text>
              <a class="th">{{ $t("system.home.menu.digital") }}</a>
            </div>
          </div>
        </div>
        <div class="content">
          <div class="content_box">
            <div class="box_inner_t">
              <div class="inner_t">
                <div class="for_box">
                  <div class="t_left">
                    <img
                      class="l_img"
                      src="./../../../public/17243775315414.png"
                      alt=""
                    />
                  </div>
                  <div class="t_right">
                    <div class="t_right_o">
                      <span>{{ $t("system.about.digital.zaixian") }}</span>
                      {{ $t("system.about.digital.dinghuo") }}
                    </div>
                    <div class="t_right_t">
                      <div class="t_r_to">
                        {{ $t("system.about.digital.we") }}
                      </div>
                      <div class="t_r_tt">
                        {{ $t("system.about.digital.kehu") }}
                      </div>
                      <p></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="box_inner">
              <div class="inner_th">
                <div class="for_box">
                  <div class="th_left">
                    <div class="t_l_t">
                      <span class="t_s">{{
                        $t("system.about.digital.dianzi")
                      }}</span>
                      {{ $t("system.about.digital.chanpin") }}
                    </div>
                    <div class="t_l_b">
                      {{ $t("system.about.digital.mulu") }}
                    </div>
                  </div>
                  <div class="th_right">
                    <img
                      class="r_img"
                      src="./../../../public/17243774803965.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="footer">
              <div class="for_box" ref="forBox">
                <div class="for_b_left">
                  <img
                    class="b_img"
                    src="./../../../public/17243160251187.png"
                    alt=""
                  />
                </div>
                <div class="for_b_right">
                  <div class="t_l_t">
                    <span class="t_s">
                      {{ $t("system.about.digital.guanli") }}
                    </span>
                    {{ $t("system.about.digital.shuju") }}
                  </div>
                  <div class="f_b_r_box">
                    <div class="r_box_left">
                      <div class="left_box_l"></div>
                      <div class="left_box_r">
                        {{ $t("system.about.digital.youxiu") }}
                      </div>
                    </div>
                    <div class="text_box">
                      <div class="text_box_t">
                        {{ $t("system.about.digital.quanche") }}
                      </div>
                      <div class="text_box_b">
                        {{ $t("system.about.digital.zhuanye") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"> </Navbar>
  </div>
</template>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.img_box {
  width: 100%;
  height: 553px;
  position: relative;
  background-image: url("./../../../public/shuzihua.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 100% 100%;
}
.img_text {
  width: 1519px;
  height: 173px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  line-height: 1.25;
}
.img_inner {
  align-items: center;
  width: 1230px;
  padding: 0 15px;
  height: 173px;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.img_main {
  align-items: center;
  width: 100%;
  height: 103px;
  font-size: 32px;
  line-height: 1.72;
  margin-top: 20px;
}
h2 {
  width: 100%;
  font-size: 46px;
  height: 50px;
  padding: 0;
  font-weight: bold;
  color: #20538c;
  margin: 0;
}
.wrap {
  width: 100%;
  height: auto;
}
.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  background-color: #fff;
  font-size: 14px;
  height: 86px;
}
.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
}
.title {
  width: 100%;
  height: 100%;
  font-size: 18px;
  margin: 0 -8px;
}
.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.content {
  width: 100%;
  height: auto;
  padding-bottom: 20px;
}
.content_box {
  position: relative;
  width: 100%;
  height: auto;
  padding: 0 0;
  background: 50% 0 no-repeat fixed;
  background-size: cover;
}
.box_inner {
  width: 100%;
  max-width: 1230px;
  margin: 0 auto;
  padding: 0 15px;
}
.inner_t {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding-top: 90px;
  align-items: flex-start;
}
.t_left {
  width: 50%;
  position: relative;
  z-index: 1;
}
.l_img {
  width: 95%;
  height: 100%;
}
.t_right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  height: 262px;
  padding: 0 0 45px;
}
.r_img {
  width: 95%;
  height: 100%;
}
.b_img {
  width: 95%;
  height: 100%;
}
.t_right_o {
  width: 100%;
  height: 66px;
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
}
span {
  display: block;
  color: #004080;
  font-size: 20px;
}
.t_right_t {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  line-height: 1.75;
}
.t_r_to {
  line-height: 1.75;
}
.t_r_tt {
  line-height: normal;
}
p {
  width: 100%;
  height: 28px;
  padding: 0;
  margin: 0;
}
.inner_th {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  min-height: 520px;
  padding-bottom: 90px;
  align-items: center;
}
.th_left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  position: relative;
  z-index: 1;
  padding: 45px;
  height: 260px;
}
.t_l_t {
  font-size: 24px;
  width: 100%;
  font-weight: bold;
  line-height: 1.5;
}
.t_s {
  display: block;
  font-size: 20px;
}
.t_l_b {
  font-size: 16px;
  line-height: 1.75;
  margin-bottom: 10px;
}
.th_right {
  width: 50%;
  position: relative;
  z-index: 1;
}
.footer {
  width: 100%;
  height: 393px;
  background: #f0f0f0;
}
.for_box {
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
  // padding-bottom: 50px;
}
.for_b_left {
  width: 50%;
  position: relative;
  z-index: 1;
  padding: 25px 0;
}
.for_b_right {
  width: 50%;
  position: relative;
  z-index: 1;
}
.for_b_right .t_l_t {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 15px;
}
.f_b_r_box {
  display: flex;
  flex-direction: column;
  // justify-content: space-between;
  font-size: 16px;
  height: 308px;
  line-height: 1.75;
  margin-top: 30px;
}
.r_box_left {
  width: 100%;
  height: auto;
  display: flex;
}
.left_box_r {
  width: 65%;
  height: 56px;
}
.text_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 16px;
  width: 100%;
  height: 165px;
}
.text_box_t,
.text_box_b {
  margin-bottom: 5px;
  line-height: 2em;
}

.inner_t,
.inner_th,
.footer {
  opacity: 0;
  transition: opacity 0.8s ease;

  &.show {
    opacity: 1;

    .t_left,
    .th_left,
    .for_b_left {
      opacity: 1;
      transform: translateX(0);
    }

    .t_right,
    .th_right,
    .for_b_right {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .t_left,
  .th_left,
  .for_b_left {
    opacity: 0;
    transform: translateX(-100px);
    transition: all 0.8s ease;
  }

  .t_right,
  .th_right,
  .for_b_right {
    opacity: 0;
    transform: translateX(100px);
    transition: all 0.8s ease;
  }
}

.box_inner_t{
  width: 100%;
  background: #f0f0f0;
}
.inner_t, .inner_th {
  width: 100%;
  padding: 50px 0;
}

.for_box {
  margin: 0 auto;
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}
</style>
